<template>
  <div class="losscustomerManage losscustomerManage-overageList">
    <PageNav :slider="slider" :openMenu="openMenu">
      <el-main>
        <div id="page-invalidCustomer">
          <div class="head-tab--nav">
            <div class="head-nav h-3">
              <!-- <span>招生CRM</span>
              <span>></span>-->
              <span class="c-normal">{{$t("overageListManage.title")}}</span>
              <div class="pull-right">
                <el-button
                  v-if="overAgeSet.exceedagetime!='' && !overAgeSet.isSetTime"
                  type="primary"
                  @click="daochu"
                >{{$t("Common.btn_export")}}</el-button>
              </div>
            </div>
          </div>
          <div class="losscustomerManage-container">
            <div class="content">
              <div class="right-title flex-al fs18 mb20">
                <span class="r-line"></span>
                <span>{{$t("overageListManage.s-title1")}}</span>
              </div>
              <div class="setting-age fs14 mb20">
                <div class="row-item flex-al">
                  <label>{{$t("overageListManage.set-text1")}}</label>
                  <p v-if="overAgeSet.exceedagetime=='' && !overAgeSet.isSetTime">
                    {{$t("overageListManage.set-text2")}}
                    <span
                      @click="handSetOverAge"
                      class="color-blue cur-pointer"
                    >{{$t("overageListManage.set-text3")}}></span>
                  </p>
                  <p v-else-if="!overAgeSet.isSetTime" class="flex-al">
                    <span>{{overAgeSet.exceedagetime}}</span>
                    <span
                      class="icon-edit"
                      @click="overAgeSet.isSetTime=true;overAgeSet.isEdit=true"
                    >
                      <i class="crmIcon-nrbj"></i>
                    </span>
                    <span class="icon-del" @click="delExceedAgeAction">
                      <i class="crmIcon-cqsc"></i>
                    </span>
                  </p>
                  <div v-if="overAgeSet.isSetTime" class="select-agetime">
                    <el-date-picker
                      type="date"
                      :placeholder="$t('overageListManage.aj')"
                      v-model="overAgeSet.exceedagetime"
                      value-format="yyyy-MM-dd"
                      style="width: 300px;"
                    ></el-date-picker>
                    <el-button
                      v-if="!overAgeSet.isEdit"
                      @click="addExceedAgeAction"
                      class="ml10"
                      type="primary"
                    >{{$t("overageListManage.ak")}}</el-button>
                    <el-button
                      v-else
                      @click="updateExceedAgeAction"
                      class="ml10"
                      type="primary"
                    >{{$t("overageListManage.ak")}}</el-button>
                  </div>
                </div>
                <div class="row-item flex-al">
                  <label>{{$t("overageListManage.set-text4")}}</label>
                  <p>{{$t("overageListManage.set-text5")}}</p>
                </div>
              </div>
              <div class="right-title flex-sb fs18 mb20">
                <div>
                  <span class="r-line"></span>
                  <span>{{$t("overageListManage.s-title2")}}</span>
                </div>
                <div v-if="MultipleClues.length>1">
                  <span
                    class="fs14"
                    style="margin-right:6px;"
                  >{{$t("overageListManage.a2")}}{{MultipleClues.length}}个</span>
                  <!-- 超龄名单转校功能限制高管有权限 -->
                  <el-button
                    v-if="postbe_crmlevel=='1'"
                    type="primary"
                    class="fs14"
                    @click="muilteTransfor"
                  >{{$t("overageListManage.a1")}}</el-button>
                </div>
              </div>
              <div
                class="flex-wrap"
                v-if="(overAgeSet.exceedagetime!='' && !overAgeSet.isSetTime) ||overAgeSet.isEdit"
              >
                <div class="flex-al mb10 mr10">
                  <span class="mr10 fs14 color-666">{{$t("overageListManage.ab")}}</span>
                  <div class="select-box flex-al">
                    <el-select
                      filterable
                      v-model="selectForm.source"
                      class="mr15"
                      style="width: 180px;"
                      clearable
                      :placeholder="$t('overageListManage.ac')"
                      @change="handleSelect()"
                    >
                      <el-option
                        v-for="item in SchoolsourceOption"
                        :key="item.frommedia_id"
                        :label="item.frommedia_name"
                        :value="item.frommedia_name"
                      ></el-option>
                    </el-select>
                  </div>
                </div>
                <div class="flex-al mb10 mr10">
                  <span class="mr10 fs14 color-666">{{$t("overageListManage.ae")}}</span>
                  <div class="time-box flex-al">
                    <el-date-picker
                      type="date"
                      :placeholder="$t('overageListManage.af')"
                      v-model="selectForm.starttime"
                      value-format="yyyy-MM-dd"
                      @change="handleSelect()"
                      style="width: 140px;"
                    ></el-date-picker>
                    <span class="ml10 mr10 fs14">{{$t("overageListManage.ag")}}</span>
                    <el-date-picker
                      type="date"
                      :placeholder="$t('overageListManage.ah')"
                      v-model="selectForm.endtime"
                      style="width: 140px;"
                      value-format="yyyy-MM-dd"
                      @change="handleSelect()"
                    ></el-date-picker>
                  </div>
                </div>
                <div class="flex-al Inquire-box mb10">
                  <div class="ipt-box">
                    <el-input
                      clearable
                      v-if="!buttonHide"
                      :placeholder="$t('overageListManage.ad')"
                      class="input-cont family-phone"
                      v-model="selectForm.keyword"
                      @change="handleSelect()"
                    ></el-input>
                    <el-button
                      v-if="!buttonHide"
                      type="primary"
                      class="btn-inquire btn-inquire2"
                      @click="handleSelect()"
                    >{{$t("overageListManage.ai")}}</el-button>
                  </div>
                </div>
              </div>
              <div class="table-cont" ref="auto_height_table">
                <div
                  class="tableList"
                  v-if="(overAgeSet.exceedagetime!='' && !overAgeSet.isSetTime) ||overAgeSet.isEdit"
                >
                  <TableList
                    :list="tableData"
                    :options="optionscaozuo"
                    :columns="columns"
                    :operates="operates"
                    @handleSelectionChange="handleSelectionChange"
                    @handleColumnChange="handleColumnChange"
                  ></TableList>
                  <el-pagination
                    style="margin-top: 20px;"
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="currentPage"
                    :page-sizes="[10, 20, 30,40]"
                    :page-size="pagesize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="dataNumber"
                  ></el-pagination>
                </div>
                <div
                  v-else
                  class="empty-overageList fs14 tc"
                  :style="{'height':optionscaozuo.tableHeight+'px'}"
                >{{$t("overageListManage.empty")}}</div>
              </div>
            </div>
          </div>
        </div>
      </el-main>
    </PageNav>
    <!-- 侧边栏查看-->
    <SliderBox
      :showSliderBox="showSliderBoxSee"
      @hideSliderBox="hideSliderSeeBox"
      :sliderWidth="sliderWidth"
    >
      <userSeeing
        :showUserSliderBox="showSliderBoxSee"
        :createJG="createJG"
        :customerId="customerId"
        :ClassMessage="ClassMessage"
        :seeSliderTitle="seeSliderTitle"
        :isTrack="isTrack"
        :isRoot="isRoot"
        :isshowfirst="true"
        :isForm="true"
        :isHome="true"
        :isnotBiding="true"
        @hideUserSliderBox="hideSliderSeeBox"
        @studentBinding="studentBinding"
        @handleSliderClick="handleSliderClick"
        @Clickedit="Clickedit"
        @leaning="leaning"
        @onFllowSubmit="onFllowSubmit"
        @ClickFloow="ClickFloow"
      ></userSeeing>
    </SliderBox>
    <!-- 转校弹窗 -->
    <div class="small-dialog slider-leavePark" v-if="leavePark">
      <el-dialog
        :title="$t('overageListManage.a3')"
        :visible="leavePark"
        width="500px"
        @close="handleCloseFrame()"
      >
        <div class="dialog-content">
          <div class="child-details" style="display: flex;flex-wrap: wrap;">
            <div class="img-list flex-al mr5" v-for="(item,index) of TransferList" :key="index">
              <img
                v-if="item.client_img!=''"
                :src="item.client_img"
                style="width: 40px;height: 40px;border-radius: 50%;"
              />
              <img
                v-if="item.client_img=='' && item.client_sex==''"
                src="../../assets/images/default-img.png"
                style="width: 40px;height: 40px;border-radius: 50%;"
              />
              <img
                v-if="item.client_img=='' && item.client_sex == $t('Common.woman')"
                src="../../assets/images/default-img-women.png"
                style="width: 40px;height: 40px;border-radius: 50%;"
              />
              <img
                v-if="item.client_img=='' && item.client_sex == $t('Common.man')"
                src="../../assets/images/default-img-man.png"
                style="width: 40px;height: 40px;border-radius: 50%;"
              />
              <span class="ml5">{{item.client_cnname}} {{item.client_enname}}</span>
            </div>
          </div>
          <el-form label-width="80px" :model="leaveForm" ref="leaveForm">
            <el-form-item
              prop="reason_code"
              :label="$t('overageListManage.a4')"
              :rules="[{ required: true, message: $t('overageListManage.a5'),trigger: 'change'}]"
            >
              <el-select
                filterable
                clearable
                v-model="leaveForm.reason_code"
                style="width: 320px;"
                :placeholder="$t('overageListManage.a5')"
              >
                <el-option
                  v-for="item in reasonList"
                  :key="item.school_id"
                  :label="item.school_cnname"
                  :value="item.school_id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              :label="$t('overageListManage.a6')"
              prop="reason"
              :rules="[{ required: true, message: $t('overageListManage.a7'),trigger: 'blur'}]"
            >
              <el-input
                clearable
                type="textarea"
                class="layout-select"
                style="width: 320px;"
                :placeholder="$t('overageListManage.a7')"
                v-model="leaveForm.reason"
                max-length="50"
              ></el-input>
            </el-form-item>
          </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" size="mini" @click="handConfirm()">{{$t('Common.btn_confirm')}}</el-button>
          <el-button size="mini" @click="handleCloseFrame()">{{$t('Common.btn_cancel')}}</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import PageNav from "../../components/Nav/nav.vue";
// import echarts from "echarts";
import SliderBox from "../../components/SliderBox";
import TableList from "../../components/Table/table.vue";
import userSeeing from "../../components/User/seeing.vue";
import storelosscustomerManage from "./losscustomerManage.js";
import storeInvitationauditionmanage from "../Invitationauditionmanage/Invitationauditionmanage.js";
export default {
  name: "losscustomerManage-losscustomerManage",
  data() {
    return {
      openMenu: ["6"],
      showSliderBox: false,
      showSliderBoxSee: false,
      leaningVisible: false,
      createJG: false,

      // 超龄日期设置
      overAgeSet: {
        isSetTime: false, //是否设置超龄日期
        isEdit: false, //是否编辑
        exceedagetime: "" //超龄日期
      },
      seeSliderTitle: this.$t("losscustomerManage.aj"),
      clientLevelNum: "", //存储意向星级数目
      ClassMessage: {}, //选择的试听班级
      inviteInfor: [],
      customerId: "", // 客户id
      isTrack: false, //是否点击跟进
      isRoot: false,
      //绑定学员
      BindstudentFrom: {
        name: "",
        relation: ""
      },
      chiefPerson: [], //主负责人
      fu_chiefPerson: [], //副负责人
      FriendName: [], //用户绑定人员名称
      FriendRelation: [], //用户绑定关系
      followFormid: "",
      layoutVisible: false, //分配

      // 分页的数据
      dataNumber: 0, //数据总数
      pagenum: "1",
      pagesize: 10,
      currentPage: 1,
      basicinformation: [],
      dialogVisible: false,
      //筛选条件
      selectForm: {
        source: "",
        starttime: "",
        endtime: "",
        keyword: ""
      },
      //多条线索信息
      MultipleClues: [],
      // 招生渠道类型
      SchoolsourceOption: [],
      visitedJG: false,
      visitingJG: false,
      levelNum: 5, //侧边栏个数
      sliderWidth: "700px", //侧边栏宽度
      activeName: "first",
      buttonHide: false,
      // 侧边栏 资料建档

      // 表格数据
      columnWidth: ["200", "200", "150", "150", "250", "250", "250", "250"], //表格宽度
      tableData: [],
      optionscaozuo: {
        mutiSelect: true, // 是否支持列表项选中功能
        loading: true, //数据loading
        highlightCurrentRow: true, // 是否支持当前行高亮显示
        tableHeight: 0, //表格高度
        errortip: ""
        // specialColumns:true//特殊列
      },
      columns: [],
      operates: {
        width: 150,
        label: "操作",
        align: "center",
        fixed: "right",
        list: [
          {
            id: "1",
            label: this.$t("overageListManage.a3"),
            type: "text",
            show: true,
            disabled: false,
            trunSchool:true,//转校
            method: (index, row) => {
              this.leaveForm.reason = "";
              this.leaveForm.reason_code = "";
              let newArr = [];
              newArr.push(row);
              this.TransferList = newArr;
              this.getAllSchoolApi(); // 目标学校
              this.leavePark = !this.leavePark;
            }
          }
        ]
      }, // 列操作按钮
      defaultProps: {
        children: "children",
        label: "label"
      },
      //弹窗--转校----开始
      leavePark: false,
      leaveForm: {
        reason_code: "", //转校原因
        reason: "" //异动原因
      },
      //转校-select
      reasonList: [],
      TransferList: [] // 选择的需要转校的数据
      //弹窗--转校----结束
    };
  },
  components: {
    PageNav,
    SliderBox,
    userSeeing,
    TableList
  },
  updated() {
    this.fullscreenLoading = false;
  },
  created() {
    
    this.slider = this.$store.state.Slider;
    this.token = this.$store.state.USER_TOKEN;
    this.marketer_id = this.$store.state.MARKETER_ID;
    this.school_id = this.$store.state.SCHOOL_ID;
    this.company_id = this.$store.state.COMPANY_ID;
    // 权限判断
    this.postbe_crmlevel = this.$store.state.POSTBE_CRMLEVEL;
    this.getExceedAgeApi(); // 超龄名单 ->超龄日期
    this.getSource();
  },
  methods: {
    // 超龄名单 ->超龄日期
    getExceedAgeApi() {
      storelosscustomerManage
        .getExceedAgeApi({
          marketer_id: this.marketer_id,
          token: this.token,
          company_id: this.company_id,
          school_id: this.school_id
        })
        .then(res => {
          let list = res.data.data.list;
          if (list) {
            this.overAgeSet.exceedagetime = list.exceed_time;
            this.ExceedAge("");
          } else {
            this.overAgeSet.exceedagetime = "";
          }
          this.computTableHeight();
          // this.SchoolsourceOption = res.data.data.list;
        });
    },
    // 超龄名单列表管理表格数据
    ExceedAge() {
      var $source = this.selectForm.source;
      if ($source == this.$t("Common.options")) {
        $source = "";
      }
      storelosscustomerManage
        .ExceedAge({
          marketer_id: this.marketer_id,
          token: this.token,
          school_id: this.school_id,
          company_id: this.company_id,
          is_count: "1", //是否需要总数，可以不传
          p: this.currentPage,
          num: this.pagesize,
          // 非必须传
          starttime: this.selectForm.starttime,
          endtime: this.selectForm.endtime,
          client_source: $source,
          exceedagetime: this.overAgeSet.exceedagetime, //超龄日期 2019-12-30格式
          keyword: this.selectForm.keyword
        })
        .then(res => {
          // 
          this.tableData = res.data.data.list;
          this.dataNumber = parseInt(res.data.data.allnum);
         
          var Columns = res.data.data.field;
          this.columns = this.$Common.handleTable(
            Columns,
            this.columnWidth,
            true,
            -1
          );
          this.columns[0].isfixed = true;
          this.columns[0].fixed = "left";
          this.optionscaozuo.loading = false;
          if (res.data.code !== 200) {
            this.optionscaozuo.errortip = res.data.msg;
          }
          // (() => {})(this.columns)
        });
    },
    // 获取招生渠道类型
    getSource() {
      storelosscustomerManage
        .getSource({
          marketer_id: this.marketer_id,
          token: this.token,
          company_id: this.company_id,
          school_id: this.school_id
        })
        .then(res => {
          (() => {})(res.data.data.list);
          this.SchoolsourceOption = res.data.data.list;
          this.SchoolsourceOption.unshift({
            frommedia_id: "",
            frommedia_name: this.$t("Common.options")
          });
        });
    },
    // 超龄名单 ->添加超龄日期
    addExceedAgeAction() {
      storelosscustomerManage
        .addExceedAgeAction({
          marketer_id: this.marketer_id,
          token: this.token,
          company_id: this.company_id,
          school_id: this.school_id,
          exceed_time: this.overAgeSet.exceedagetime
        })
        .then(res => {
          (() => {})(res.data);
          if (res.data.code === 200) {
            this.$message({
              message: res.data.msg,
              type: "success"
            });
            this.getExceedAgeApi(); // 超龄名单 ->超龄日期
            this.overAgeSet.isSetTime = false;
          } else {
            this.$message({
              message: res.data.msg,
              type: "error"
            });
          }
        });
    },
    // 超龄名单 ->编辑超龄日期
    updateExceedAgeAction() {
      storelosscustomerManage
        .updateExceedAgeAction({
          marketer_id: this.marketer_id,
          token: this.token,
          company_id: this.company_id,
          school_id: this.school_id,
          exceed_time: this.overAgeSet.exceedagetime
        })
        .then(res => {
          (() => {})(res.data);
          if (res.data.code === 200) {
            this.$message({
              message: res.data.msg,
              type: "success"
            });
            this.getExceedAgeApi(); // 超龄名单 ->超龄日期
            this.overAgeSet.isSetTime = false;
            this.overAgeSet.isEdit = false;
          } else {
            this.$message({
              message: res.data.msg,
              type: "error"
            });
          }
        });
    },
    // 超龄名单 ->删除超龄日期
    delExceedAgeAction() {
      storelosscustomerManage
        .delExceedAgeAction({
          marketer_id: this.marketer_id,
          token: this.token,
          company_id: this.company_id,
          school_id: this.school_id,
          exceed_time: this.overAgeSet.exceedagetime
        })
        .then(res => {
          if (res.data.code === 200) {
            this.$message({
              message: res.data.msg,
              type: "success"
            });
            this.getExceedAgeApi(); // 超龄名单 ->超龄日期
            this.overAgeSet.isSetTime = false;
          } else {
            this.$message({
              message: res.data.msg,
              type: "error"
            });
          }
        });
    },

    // 选择查询
    handleSelect() {
      this.currentPage = 1;
      this.ExceedAge("");
    },
    // 设置超龄日期
    handSetOverAge() {
      this.overAgeSet.isSetTime = !this.overAgeSet.isSetTime;
    },
    hideSliderSeeBox() {
      this.showSliderBoxSee = false;
    },
    //跟班试听
    leaning() {
      this.leaningVisible = true;
    },
    // 获取单个客户的绑定关系
    getFriendRelationData(id) {
      storeInvitationauditionmanage
        .getFriendRelation({
          marketer_id: this.marketer_id,
          token: this.token,
          company_id: this.company_id,
          school_id: this.school_id,
          client_id: id
        })
        .then(res => {
          (() => {})(res.data.data.list);
          this.FriendRelation = res.data.data.list;
        });
    },
    // 绑定学员->获取人员名称
    getClientNameData(keyword) {
      storeInvitationauditionmanage
        .getClientName({
          marketer_id: this.marketer_id,
          token: this.token,
          company_id: this.company_id,
          school_id: this.school_id,
          client_cnname: keyword
        })
        .then(res => {
          // (() => {})(res.data.data.list);
          this.FriendName = res.data.data.list;
          this.loading = false;
        });
    },
    // 远程搜索绑定学员的名称
    remoteMethod(query) {
      (() => {})(query);
      if (query !== "") {
        this.loading = true;
        this.getClientNameData(query);
      } else {
        this.FriendName = [];
      }
    },
    //绑定学员提交
    onBindSubmit() {
      // (() => {})(this.BindstudentFrom);
      storeInvitationauditionmanage
        .bindingClient({
          token: this.token,
          marketer_id: this.marketer_id,
          from_client_id: this.from_client_id,
          to_client_id: this.BindstudentFrom.name,
          binding_friend_relation: this.BindstudentFrom.relation
        })
        .then(res => {
          // (() => {})(res.data);
          if (res.data.code === 200) {
            // this.$Tool.successTip(res.data.msg);
            this.$message({
              message: res.data.msg,
              type: "success"
            });
            this.getAuditionData(this.pagenum, "");
            this.createJG = false;
          } else {
            this.$message({
              message: res.data.msg,
              type: "error"
            });
          }
        });
    },
    // 绑定学员显示
    studentBinding() {
      this.BindstudentFrom = {
        name: "",
        relation: ""
      }; //数据初始化
      this.getFriendRelationData();
      this.createJG = true;
    },
    //查看点击编辑
    Clickedit() {
      this.showSliderBoxSee = false;
      this.showSliderBox = true;
    },
    //点击查看
    handleColumnChange(k, v) {
      this.isRoot = false;
      this.activeName = "first";
      this.iscanEdit = true;
      this.from_client_id = v.client_id;
      this.customerId = v.client_id; //存储客户ID
      // this.getclientOneData(v.client_id);
      // this.getclientOneTrackData(v.client_id);
      // this.getFriendRelationData(v.client_id);
      // this.getclientOneInviteData(v.client_id); //柜询记录
      // this.getclientOneAuditionData(v.client_id); //试听记录
      // this.getBindingClientData(v.client_id);//绑定学员信息
      this.showSliderBoxSee = true;
    },
    //跟进提交
    onFllowSubmit(v) {
      // v.track_intention_level = this.clientLevelNum.length;
      v.token = this.token;
      v.marketer_id = this.marketer_id;
      v.school_id = this.school_id;
      v.company_id = this.company_id;
      if (this.followFormid != "") {
        v.client_id = this.followFormid;
      }
      // v.client_id=this.followFormid;
      (() => {})(v);
      storeInvitationauditionmanage.settingtrackClient(v).then(res => {
        (() => {})(res.data);
        if (res.data.code === 200) {
          // this.$Tool.successTip(res.data.msg);
          this.$message({
            message: res.data.msg,
            type: "success"
          });
          this.getAuditionData(this.pagenum, "");
          this.showSliderBoxSee = false;
        } else {
          this.$message({
            message: res.data.msg,
            type: "error"
          });
        }
      });
    },
    // 绑定学员点击跟进
    ClickFloow(v) {
      this.customerId = v.client_id;
    },
    hideSliderSeeBox() {
      this.showSliderBoxSee = false;
    },
    handleSliderClick(v) {
      (() => {})(v), 11111111;
      if (v == "first") {
        this.iscanEdit = true;
        //  this.getclientOneData(this.customerId);
      } else {
        if (v == "fourth") {
          this.isRoot = true;
        } else {
          this.iscanEdit = false;
          // this.isRoot=false;
        }
      }
    },
    //跟班试听
    leaning() {
      this.leaningVisible = true;
    },
    handleClose(done) {
      this.$confirm(this.$t("overageListManage.ao"))
        .then(_ => {
          (() => {})(_);
          done();
        })
        .catch(_ => {
          (() => {})(_);
        });
    },
    handleSizeChange(val) {
      (() => {})(`每页 ${val} 条`);
      this.pagesize = val;
      this.ExceedAge("");
    },
    handleCurrentChange(val) {
      (() => {})(`当前页: ${val}`);
      this.currentPage = val;
      this.ExceedAge("");
    },
    handleSelectionChange(val) {
      this.MultipleClues = val;
      if (val != "") {
        let timer = setTimeout(() => {
          this.buttonHide = true;
          clearTimeout(timer);
        }, 10);
      } else {
        this.buttonHide = false;
      }
      this.TransferList = val;
      
    },
    // 导出操作
    daochu() {
      let url = storelosscustomerManage.ExceedAge1();
      var is_export = 1;
      let language_type = this.$Tool.getStorage("language")
        ? this.$Tool.getStorage("language")
        : "zh";
      var $source = this.selectForm.source;
      if ($source == this.$t("Common.options")) {
        $source = "";
      }
      (() => {})(this.tableData.length);
      if (this.tableData.length > 0) {
        window.open(
          this.$buildExportUrl(`${url}?marketer_id=${this.marketer_id}&token=${this.token}&school_id=${this.school_id}&company_id=${this.company_id}&is_export=${is_export}&starttime=${this.selectForm.starttime}&endtime=${this.selectForm.endtime}&client_source=${$source}&exceedagetime=${this.overAgeSet.exceedagetime}&keyword=${this.selectForm.keyword}&language_type=${language_type}`),
          "_blank"
        );
      } else {
        this.$message.error(this.$t("Report.errorMessage1"));
      }
    },
    // 计算表格高度
    computTableHeight() {
      this.$nextTick(() => {
        if (this.$refs["auto_height_table"]) {
          if (
            this.overAgeSet.exceedagetime == "" &&
            !this.overAgeSet.isSetTime
          ) {
            this.optionscaozuo.tableHeight = this.$Common.getTableHeight(
              this.$refs.auto_height_table.getBoundingClientRect().top + 45
            );
          } else {
            this.optionscaozuo.tableHeight = this.$Common.getTableHeight(
              this.$refs.auto_height_table.getBoundingClientRect().top + 100
            );
          }
        }
      });
    },
    // -----转校开始------
    // 目标学校
    getAllSchoolApi() {
      storelosscustomerManage
        .getAllSchoolApi({
          marketer_id: this.marketer_id,
          token: this.token,
          company_id: this.company_id,
          school_id: this.school_id
        })
        .then(res => {
          if (res.data.code === 200) {
            this.reasonList = res.data.data.list;
          } else {
            this.reasonList = [];
          }
        });
    },
    //转校弹窗 - 确定
    handConfirm() {
      this.$refs["leaveForm"].validate(valid => {
        if (valid) {
          this.transferEAClientSchoolAction();
        } else {
          (() => {})("error submit!!");
          return false;
        }
      });
    },
    // 转校表单 - 提交
    transferEAClientSchoolAction() {
      let newArr = [];
      this.TransferList.forEach(item => {
        newArr.push(item.client_id);
      });
      storelosscustomerManage
        .transferEAClientSchoolAction({
          marketer_id: this.marketer_id,
          token: this.token,
          company_id: this.company_id,
          school_id: this.school_id,
          client_list: JSON.stringify(newArr), //学员id
          note: this.leaveForm.reason, //转校原因
          re_school_id: this.leaveForm.reason_code //转入的学校
        })
        .then(res => {
          if (res.data.code === 200) {
            this.reasonList = res.data.data.list;
            this.$message({
              message: res.data.msg,
              type: "success"
            });
            this.leavePark = !this.leavePark;
            this.getExceedAgeApi(); // 超龄名单 ->超龄日期
          } else {
            this.reasonList = [];
            this.$message({
              message: res.data.msg,
              type: "error"
            });
            this.leavePark = !this.leavePark;
          }
        });
    },
    //点击 批量转校
    muilteTransfor() {
      this.getAllSchoolApi(); // 目标学校
      this.leaveForm.reason = "";
      this.leaveForm.reason_code = "";
      this.leavePark = !this.leavePark;
    },
    //转校弹窗 - 关闭
    handleCloseFrame() {
      this.leavePark = !this.leavePark;
    }
    //------转校结束------
  },
  mounted() {
    this.$nextTick(() => {
      if (this.$refs["auto_height_table"]) {
        if (this.overAgeSet.exceedagetime == "" && !this.overAgeSet.isSetTime) {
          this.optionscaozuo.tableHeight = this.$Common.getTableHeight(
            this.$refs.auto_height_table.getBoundingClientRect().top + 45
          );
        } else {
          this.optionscaozuo.tableHeight = this.$Common.getTableHeight(
            this.$refs.auto_height_table.getBoundingClientRect().top + 200
          );
        }
      }
    });
  }
};
</script>
<style lang="less">
@import url("../../assets/less/manage.less");
@import url("losscustomerManage.less");
.losscustomerManage-overageList {
  height: 100vh;
  font-size: 20px;
  .color-blue {
    color: #20a8d8;
  }
  .setting-age {
    .row-item {
      margin-bottom: 15px;
      label {
        display: inline-block;
        color: #aaaaaa;
        width: 72px;
      }
      .icon-edit,
      .icon-del {
        margin-left: 8px;
        cursor: pointer;
        font-size: 22px;
        i {
          position: relative;
        }
      }
      .icon-edit i::after {
        content: "编辑";
        position: absolute;
        display: none;
        top: 25px;
        left: 10px;
        color: #fff;
        width: 48px;
        text-align: center;
        height: 23px;
        line-height: 23px;
        font-size: 14px;
        background: #000000;
      }
      .icon-del i::after {
        content: "删除";
        position: absolute;
        top: 25px;
        left: 10px;
        display: none;
        color: #fff;
        width: 48px;
        text-align: center;
        height: 23px;
        line-height: 23px;
        font-size: 14px;
        background: #000000;
      }
      .icon-edit:hover {
        i:before {
          color: #20a3d2;
        }
        i::after {
          display: block;
        }
      }
      .icon-del:hover {
        i:before {
          color: #d30f0f;
        }
        i::after {
          display: block;
        }
      }
    }
  }
  .empty-overageList {
    color: #aaa;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
</style>
